<template>
  <div class="check-status-by-name-form small-margin-top-s medium-margin-top-m">
    <div class="grid-container full">
      <div class="grid-x">
        <div class="small-12 medium-5">
          <p class="small gray-1-color">
            {{ ORDER_LOOKUP.requiredField }}
          </p>
          <Form v-slot="{ meta }" @submit="onSubmit">
            <InputText v-model="firstName" name="firstName" label="First Name*" rule="firstName" />
            <InputText v-model="lastName" name="lastName" label="Last Name*" rule="lastName" />
            <InputText v-model="phoneNumber" name="phoneNumber" label="Phone Number*" rule="phone" mask="phoneFormat" />
            <PrivacyPractices class="small-12 margin-top-s" />
            <button
              name="checkStatusBtn"
              type="submit"
              :disabled="!meta.valid"
              class="primary button expanded small-margin-top-xs medium-margin-top-s"
            >
              {{ ORDER_LOOKUP.checkStatusForm.checkStatusLabel }}
            </button>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useEnvPropsStore } from '@/stores/useEnvPropsStore';
import { useFurnitureStore } from '@/stores/ppe/useFurnitureStore';
import Form from '@atomic-ui/form';
import InputText from '@atomic-ui/inputText/InputText';
import { fireTag } from '@vue-util/tagManager';
import PrivacyPractices from '@/components/common/PrivacyPractices';
import { ORDER_LOOKUP, PPE_ERROR_TAG } from 'config';

const envPropsStore = useEnvPropsStore();
const furnitureStore = useFurnitureStore();

const firstName = ref('');
const lastName = ref('');
const phoneNumber = ref('');

const isMew = computed(() => envPropsStore.envProps?.isMew);
const getFurnitureStatus = (payload) => furnitureStore.GET_FURNITURE_STATUS(payload, envPropsStore.envProps);
const updateFurnitureApiError = computed(() => furnitureStore.updateFurnitureApiError);

const onSubmit = async (values) => {
  const payloadObj = {
    salesCheckNumber: '',
    salesPhoneNumber: '',
    firstName: values.firstName,
    lastName: values.lastName,
    phoneNumber: values.phoneNumber,
    requestType: 'NAME_PHONE_NUMBER',
  };
  await getFurnitureStatus({
    payloadObj,
    envProp: {
      isMew: isMew.value,
    },
  });
  if (updateFurnitureApiError.value) {
    fireTag('link', {
      ...PPE_ERROR_TAG.error,
      error_code: [updateFurnitureApiError.value?.errorCode || PPE_ERROR_TAG.defaultErrorCode],
      error_message: [updateFurnitureApiError.value?.message],
    });
  }
};
</script>
